import useStateReducer from '@/app/hooks/useStateReducer';
import { useState } from 'react';
import { FEATURE_SELECTED } from '../components/CscMap/utils/utils';
import {
    IFeatureSelectedOnGridParams,
    ISelectFeaturesOnMapParams,
    TVectorGeometrySource,
} from '../types';

export const useFeatureSelection = () => {
    const [locationsSource, setLocationsSource] =
        useState<TVectorGeometrySource>(null);
    const [bottomGridSource, setBottomGridSource] =
        useState<TVectorGeometrySource>(null);
    const [lastSelectedLocation, setLastSelectedLocation] = useState('');
    const [lastSelectedBottomItem, setLastSelectedBottomItem] = useState('');

    const initialState = {
        clientsAndLocations: [],
        Tasks: [],
        ContractItems: [],
        Events: [],
        EventsByRfid: [],
    };

    const { values: selectedItems, handleChangeValues: selectItems } =
        useStateReducer(initialState);

    const handleSelectLastItem = (sourceSetId: string, last: string) => {
        sourceSetId === 'clientsAndLocations'
            ? setLastSelectedLocation(last)
            : setLastSelectedBottomItem(last);
    };

    const handleSelectFeaturesOnMap = ({
        items,
        sourceSetId,
        lastItemId,
    }: ISelectFeaturesOnMapParams) => {
        handleSelectLastItem(sourceSetId, lastItemId);
        selectItems(sourceSetId, items);
    };

    const onFeatureSelected = ({
        source,
        sourceSetId,
        items,
    }: IFeatureSelectedOnGridParams) => {
        if (!source) return;

        const itemSet = new Set(items);
        const features = source.getFeatures();
        selectItems(sourceSetId, items);

        features.forEach((feature) => {
            const data = feature?.get('data');
            const id = data?.id;
            feature.unset('selected');
            if (id && itemSet.has(id)) {
                feature.set('selected', FEATURE_SELECTED);
            }
        });
    };

    return {
        locationsSource,
        setLocationsSource,
        bottomGridSource,
        setBottomGridSource,
        lastSelectedLocation,
        lastSelectedBottomItem,
        selectedItems,
        handleSelectLastItem,
        handleSelectFeaturesOnMap,
        onFeatureSelected,
    };
};
